import { render, staticRenderFns } from "./add.vue?vue&type=template&id=98cbd480&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cbd480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98cbd480')) {
      api.createRecord('98cbd480', component.options)
    } else {
      api.reload('98cbd480', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=98cbd480&scoped=true", function () {
      api.rerender('98cbd480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mediaManage/entryManage/components/add.vue"
export default component.exports